import React, {Component} from "react";
import CommToolContext from "containers/common/comm_tool_context";
import {withRouter} from 'react-router-dom';
import ProjectTabsList from "components/ProjectTabsList";
import ProjectTabsNavBar from "../../components/ProjectTabsList/ProjectTabsNavBar";

class ActiveTabs extends Component {
    state = {
        teamMembers :[]
    };

    componentDidMount() {
        const {
            setActiveProject,
        } = this.props.context;
        setActiveProject(this.props.project);
    }

    render() {
        const {project, history, match} = this.props;
        return (
            <CommToolContext.Consumer>
                {context => (
                    <ProjectTabsNavBar  project={project} context={context} />
                )}
            </CommToolContext.Consumer>
        );
    }
}

ActiveTabs.contextType = ActiveTabs;
export default withRouter(ActiveTabs);
